import type React from 'react';
import { Suspense } from 'react';

import { redirectTo, useLocation } from '@xing-com/crate-core-router';
import {
  XING_JOBS_SEARCH_PATH,
  XING_JOBS_SEARCH_KI_PATH,
} from '@xing-com/crate-core-routes';
import { SearchLoadingSkeleton } from '@xing-com/crate-search-utils';

import { Container } from './container';

const removeTrailingSlashes = (pathname: string): string =>
  pathname.replace(/\/+$/, '') || '/';

export const Component: React.FC = () => {
  const { pathname, search, hash } = useLocation();

  if (removeTrailingSlashes(pathname) === XING_JOBS_SEARCH_PATH) {
    redirectTo(`${XING_JOBS_SEARCH_KI_PATH}${search}${hash}`, 301);
  }

  return (
    <Suspense fallback={<SearchLoadingSkeleton />}>
      <Container />
    </Suspense>
  );
};
